/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLeftTail = createReactComponent("arrow-left-tail", "IconArrowLeftTail", [
  ["path", { d: "M18 12h-15", key: "svg-0" }],
  ["path", { d: "M6 9l-3 3l3 3", key: "svg-1" }],
  ["path", { d: "M21 9l-3 3l3 3", key: "svg-2" }]
]);

export { IconArrowLeftTail as default };
//# sourceMappingURL=IconArrowLeftTail.js.map
